import { Guide } from '@repo/types';
import { Card, TextLink, Typography } from 'components';
import styles from './AdditionalResources.module.css';

interface ResourceCardProps {
  guide: Guide;
}

export default function ResourceCard({ guide }: ResourceCardProps) {
  return (
    <Card cardBodyClassName={styles.cardBody} className={styles.resourceCard}>
      <img
        src={guide.image_url ?? ''}
        alt={`${guide.display_title} image`}
        className={styles.image}
      />
      <div className={styles.textsContainer}>
        <Typography variant='body-s'>{guide.display_title}</Typography>
        <TextLink label='View article' to={guide.url ?? '/'} target='_blank' />
      </div>
    </Card>
  );
}
